export const PERCENTUAL_FGTS = 0.08;
export const PERCENTUAL_PROVISAO_13_TERCEIRO = 0.0833;
export const PERCENTUAL_ENCARGOS_13_TERCEIRO = 0.355;
export const PERCENTUAL_FERIAS_TERCO = 1 / 12 / 3;
export const PERCENTUAL_ENCARGOS_FERIAS = 0.355;
export const PERCENTUAL_FGTS_RESCISAO = 0.4;
